// import * as ActionType from "../Actions/Types";
// import StoreState from "./initialState";
// import cloneDeep from "lodash/cloneDeep";
// import {GET_APPLICANT_RESPONSE, GET_QUERIES} from "../Actions/Types";

// export default function QueriesReducer(
//   state = StoreState.queries, action ) {
//   switch (action.type) {
//     case ActionType.GET_QUERIES:
//       var s = cloneDeep(state);
//       s.queries = action.data;
//       return s;
//     case ActionType.GET_APPLICANT_RESPONSE:
//       var s1 = cloneDeep(state);
//       s1.response = action.data;
//       return s1;
//       case ActionType.GET_BM_QUERY:
//         var s3 = cloneDeep(state);
//         s3.BMQueryData = action.payload;
//         return s3;
//       case ActionType.GET_STAFF_BM_QUERY:
//         var s2 = cloneDeep(state);
//         s2.StaffBMQueryData = action.payload;
//         return s2;
//     default:
//       return state;
//   }
// }
